/** Small structured counters for the session-boundary seams. */
const counters = new Map();

export function recordSessionBoundaryMetric(name, dimensions = {}) {
  const metric = String(name || 'unknown');
  const key = `${metric}:${JSON.stringify(dimensions)}`;
  const value = (counters.get(key) || 0) + 1;
  counters.set(key, value);
  // Structured console records are queryable in browser diagnostics and keep
  // this client-only surface independent of a particular analytics vendor.
  console.info('[SessionBoundaryMetric]', { metric, value, ...dimensions });
  return value;
}

export function sessionBoundaryMetricsSnapshot() {
  return Object.fromEntries(counters);
}
